import { useQuery } from "@apollo/client";
import {
  Flex,
  Avatar,
  Text,
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  MenuDivider,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import { capitalize, get } from "lodash";
import React, { FC, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { removeAuthToken } from "../../utils/token";
import { GET_USER } from "../modals/user/update/queries";
import UserUpdate from "../modals/user/update/UserUpdate";

type HeaderProps = {};

const HeaderLayout: FC<HeaderProps> = (props) => {
  const { auth } = useContext(AuthContext);
  const id = auth.id;

  const { data, loading } = useQuery(GET_USER, {
    variables: {
      id,
    },
    fetchPolicy: "network-only",
  });

  const {
    isOpen: isUpdateProfileModalOpen,
    onOpen: onOpenUpdateProfileModal,
    onClose: onCloseUpdateProfileModal,
  } = useDisclosure();

  const user = get(data, "user");
  return (
    <Flex
      px="5"
      py="3"
      bg="primary"
      alignItems="center"
      justifyContent="space-between"
    >
      <Text fontSize="2xl" fontWeight="bold" color="white">
        FreeshU
      </Text>

      <Flex>
        <Menu>
          <MenuButton
            as={Button}
            rounded={"full"}
            variant={"link"}
            cursor={"pointer"}
            minW={0}
          >
            {loading ? (
              <Spinner />
            ) : (
              <Avatar src={user.imageURL} name={user.name} />
            )}
          </MenuButton>
          <MenuList>
            <MenuItem onClick={onOpenUpdateProfileModal}>Profile</MenuItem>

            <MenuDivider />
            <MenuItem
              onClick={() => {
                removeAuthToken();
                window.location.reload();
              }}
            >
              Logout
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>

      {!loading && (
        <UserUpdate
          isOpen={isUpdateProfileModalOpen}
          onOpen={onOpenUpdateProfileModal}
          onClose={onCloseUpdateProfileModal}
          id={data?.user.id}
          title={`${capitalize(data?.user.name)} | Profile`}
          disabledFields={
            auth.role !== "ADMIN" ? ["status", "brgy_code", "city_code"] : []
          }
        />
      )}
    </Flex>
  );
};

export default HeaderLayout;
